// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HaveIdea-module--wrapper--Fn5VR","title":"HaveIdea-module--title--25blP","btn":"HaveIdea-module--btn--2mthi"};